import React, { useEffect, useState } from "react";
import Cookies from "js-cookie";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import CustomInput from "../../ui/CustomInput/index.js";
import { useForm } from "react-hook-form";
import { zodResolver } from "@hookform/resolvers/zod";
import {
  useForgotPassword,
  useLoginUser,
} from "../../lib/queries/queriesAndMutations";
import { loginSchema } from "../../lib/validation";
import CustomButton from "../../ui/CustomButton";

const LoginForm = (props) => {
  const [showPassword, setShowPassword] = useState(false);
  const navigate = useNavigate();
  const { mutateAsync: loginUser, isPending } = useLoginUser();
  const { mutateAsync: forgotPassword, isPending: isPendingForgotPassword } =
    useForgotPassword();
  useEffect(() => {
    const token = Cookies.get("token");
    if (token) {
      navigate("/home");
    }
  }, []);

  const {
    handleSubmit,
    watch,
    control,
    formState: { errors },
  } = useForm({
    defaultValues: { username: "", password: "" },
    resolver: zodResolver(loginSchema),
  });

  const processForm = async (data) => {
    try {
      const response = await loginUser(data);
      //console.log({ response });
      if (response.status === 201 || response.status === 200) {
        if (response.data.token) {
          Cookies.set("token", response.data.token, { expires: 30 });
          navigate("/home");
          toast.success("ورود موفق");
        } else {
          navigate("/tow-step-otp-confirm", {
            state: {
              phone: watch("username"),
              towFaType: response.data["2fa_type"],
            },
          });
        }
      }
    } catch (error) {
      //console.log(error, "eroor");
    }
  };

  const handleForgotPassword = async (e) => {
    e.preventDefault();
    const phone = watch("username");

    if (!phone) {
      toast.error("شماره تلفن را وارد نمایید");
      return;
    }
    if (String(phone).length !== 11) {
      toast.error("شماره تلفن  11 رقمی می باشد ");
      return;
    }
    try {
      const response = await forgotPassword(phone);
      if (response.status === 201 || response.status === 200) {
        navigate("/forgot-password-otp-confirm", { state: { phone } });
      }
    } catch (error) {
      console.error("sendEmail", error);
    }
  };

  return (
    <div className="flex flex-col gap-3">
      <p className="text-[#7f7f7f] text-[14px]  md:text-[22px] mb-8  font-bold">
        کاربر گرامی
        <br /> جهت ورود به وندا ولت اطلاعات زیر را وارد نمایید
      </p>

      <>
        <form
          onSubmit={handleSubmit(processForm)}
          className="flex flex-col gap-6"
        >
          <CustomInput
            tabIndex={"8"}
            control={control}
            // disabled={disabled}
            name={"username"}
            label={"شماره موبایل"}
            className={"order-last"}
            setShowPassword={setShowPassword}
            type={"number"}
            errors={errors?.username}
          />
          <CustomInput
            tabIndex={"8"}
            control={control}
            // disabled={disabled}
            name={"password"}
            label={"رمز عبور"}
            className={"order-last"}
            type={showPassword ? "text" : "password"}
            showPassword={showPassword}
            setShowPassword={setShowPassword}
            isPassword={true}
            errors={errors?.password}
          />

          <CustomButton
            type={"submit"}
            isLoading={isPending}
            className="text-[#FFFFFF] bg-[#39A78E] hover:bg-[#2A7A67] py-[12px]  px-[70px] rounded mt-4 text-[24px] w-fit mx-auto font-bold"
          >
            ورود
          </CustomButton>

          <div className="flex items-center gap-1 ">
            <span>رمز عبور را فراموش کرده اید؟</span>
            <CustomButton
              type={"button"}
              isLoading={isPendingForgotPassword}
              onClick={(e) => handleForgotPassword(e)}
              className="text-dark w-fit hover:text-primary-90  underline underline-offset-8  "
            >
              {" "}
              بازیابی رمز عبور
            </CustomButton>
          </div>
        </form>
      </>
    </div>
  );
};

export default LoginForm;
